// @ts-nocheck

import styled from 'styled-components';

export const Wrapper = styled.div.withConfig({ displayName: "styles__Wrapper", componentId: "sc-1z0h5it-0" })(["display:flex;height:100vh;"]);



export const Content = styled.div.withConfig({ displayName: "styles__Content", componentId: "sc-1z0h5it-1" })(["display:flex;width:100%;"]);



export const MapWrapper = styled.div.withConfig({ displayName: "styles__MapWrapper", componentId: "sc-1z0h5it-2" })(["width:calc(100% - 330px);position:relative;"]);



export const Sidebar = styled.div.withConfig({ displayName: "styles__Sidebar", componentId: "sc-1z0h5it-3" })(["width:40px;background:#3d4042;box-sizing:border-box;padding:8px;"]);





export const BackButton = styled.button.withConfig({ displayName: "styles__BackButton", componentId: "sc-1z0h5it-4" })(["width:24px;height:24px;border:none;outline:none;border-radius:4px;background:white;cursor:pointer;"]);








export const Frame = styled.iframe.withConfig({ displayName: "styles__Frame", componentId: "sc-1z0h5it-5" })(["height:100vh;width:100%;"]);



export const FrameContainer = styled.div.withConfig({ displayName: "styles__FrameContainer", componentId: "sc-1z0h5it-6" })(["position:relative;width:100%;"]);
